export default __webpack_public_path__ + "static/media/sewing-machine.b881f2cc.svg";